import type { ObrasKanbanBoardProps } from "./types-obras-kanban-board";
import { ObrasKanbanBoardView } from "./view-obras-kanban-board";

/**
 * Quadro de Cards de obra (Figma 12699:608278): o `Kanban` do DS com uma coluna por status, sem arrastar, e o `ObraCard` em
 * cada card. A tela monta as colunas (status operacional ou financeiro, paginação por status) e este quadro as desenha com
 * as mesmas medidas, "Mostrar mais obras" incluído.
 */
export function ObrasKanbanBoard(props: ObrasKanbanBoardProps) {
  return <ObrasKanbanBoardView {...props} />;
}

export type * from "./types-obras-kanban-board";
